export default {
  checkout: () => import("/src/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/src/layouts/default.vue").then(m => m.default || m)
}